var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.openChat)?_c('div',{attrs:{"id":"voiceflow-chat"}}):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }